import React from 'react'
import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useState
} from 'react'
import Button from '~/components/Button'
import Modal from '~/components/Modal'
import SETTINGS from '@verzekeringapp-mono/shared/src/constants/settings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { logEvent } from '~/utils/firebase'

const EmergencyModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => {
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  return (
    <EmergencyModalContext.Provider value={{ open, close, isOpen }}>
      {children}

      {isOpen && (
        <Modal
          modalIcon={
            <div className='absolute -top-[40px] z-10 flex h-[80px] w-[80px] items-center justify-center rounded-full border-4 border-surface-modal bg-action-destructive-background p-4 text-icon-on-danger'>
              <FontAwesomeIcon
                icon='phone-plus'
                size='xl'
              />
            </div>
          }
          onClose={close}
        >
          <div className='relative flex-col flex justify-center items-center text-center gap-4'>
            <h2 className='mt-8 text-xl font-medium text-text-primary'>
              Noodnummer bellen
            </h2>

            <p>
              Weet je zeker dat je het noodnummer wilt bellen? Je wordt dan direct
              in contact gebracht met de alarmcentrale van Nh1816.
            </p>

            <a
              className='danger-btn mt-4'
              href={`tel:${SETTINGS.emergencyPhoneNumber}`}
              onClick={() => logEvent('emergency_number')}
            >
              Bel noodnummer
            </a>

            <p>of</p>

            <Button
              variant='outline-brand'
              onClick={close}
            >
              Nee, annuleer
            </Button>
          </div>
        </Modal>
      )}
    </EmergencyModalContext.Provider>
  )
}

type EmergencyModalContextType = {
  open: () => void;
  close: () => void;
  isOpen?: boolean;
};

const EmergencyModalContext = createContext<EmergencyModalContextType>({
  open: () => {
    throw new Error('open() called outside of EmergencyModalProvider')
  },
  close: () => {
    throw new Error('close() called outside of EmergencyModalProvider')
  },
  isOpen: false
})

export const useEmergencyModalContext = () => useContext(EmergencyModalContext)

export default EmergencyModalProvider
